<template>
    <div class="overflow-hidden" style="height: 100%; display:grid;">
        <div class="mb-3 p-1 d-flex">
            <div
                class="btn btn-danger mr-2 ms-2 d-flex align-items-center"
                :class="{ active: currentLanguage === 'en' }"
                @click="setLanguage('en')"
                style="width: auto;">
                <img src="~@images/flag-gb.svg" alt="EN" class="me-2 mr-1" style="max-height: 20px; width: auto;">
                English
            </div>
            <div
                class="btn btn-danger ms-2 d-flex align-items-center"
                :class="{ active: currentLanguage === 'fi' }"
                @click="setLanguage('fi')"
                style="width: auto;">
                <img src="~@images/flag-fi.svg" alt="FI" class="me-2 mr-1" style="max-height: 20px; width: auto;">
                Suomi
            </div>
        </div>
        <div class="overflow-auto" style="height: 100%">
            <div v-if="currentLanguage === 'en'">
                <table class="table table-striped fs-5 border-1" style="border-spacing: 0;">
                    <thead style="position: sticky; top: 0; z-index: 1000; background: #fff;">
                    <tr>
                        <th class="column-1"></th>
                        <th colspan="2" class="right-border">Outsiders</th>
                        <th colspan="5">Insiders (part of a company)</th>
                    </tr>
                    <tr class="font-weight-bold">
                        <td class="column-1">Roles</td>
                        <td>Outside inspector</td>
                        <td class="right-border">Subcontractor</td>
                        <td>User</td>
                        <td>Project manager</td>
                        <td>Company Manager</td>
                        <td>Admin</td>
                    </tr>
                    <tr>
                        <td class="column-1">Role short description.</td>
                        <td style="font-size: 11px;">Can view Site monitoring section and comment on markings in mobile
                            and manager (only projects they are assigned to).
                        </td>
                        <td class="right-border" style="font-size: 11px;">Can only work on projects they are assigned to, can not view other
                            projects (outside organization personnel).
                        </td>
                        <td style="font-size: 11px;">Can only work on projects they are assigned to, can not view other
                            projects (inside organization personnel).
                        </td>
                        <td style="font-size: 11px;">All features available except deleting
                            products/reports/tools/project users.
                        </td>
                        <td style="font-size: 11px;">All features available except deleting company users.</td>
                        <td style="font-size: 11px;">All features available.</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td colspan="7" class="text-white font-weight-bold"
                            style="background-color: #E20613; text-align: left;">Functions for Manager app.
                        </td>
                    </tr>
                    <tr>
                        <td class="column-1">See projects what are assigned to them.</td>
                        <td>yes</td>
                        <td class="right-border">yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Password change possible by admin.</td>
                        <td>no (password cannot be created by the any company admin).</td>
                        <td class="right-border">no (password cannot be created by the any company admin).</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can see project dashboard.</td>
                        <td>yes</td>
                        <td class="right-border">yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can edit project dashboard with its functions.</td>
                        <td>no</td>
                        <td class="right-border">no</td>
                        <td>no</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can see files.</td>
                        <td>yes</td>
                        <td class="right-border">yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can edit files.</td>
                        <td>no</td>
                        <td class="right-border">no</td>
                        <td>no</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can see products.</td>
                        <td>yes</td>
                        <td class="right-border">yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can edit own products.</td>
                        <td>no</td>
                        <td class="right-border">no</td>
                        <td>no</td>
                        <td>no</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can see site tools.</td>
                        <td>no</td>
                        <td class="right-border">yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can add site tools.</td>
                        <td>no</td>
                        <td class="right-border">no</td>
                        <td>no</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can delete site tools.</td>
                        <td>no</td>
                        <td class="right-border">no</td>
                        <td>no</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can see reports.</td>
                        <td>yes</td>
                        <td class="right-border">yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can edit reports.</td>
                        <td>no</td>
                        <td class="right-border">no</td>
                        <td>no</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can delete reports.</td>
                        <td>no</td>
                        <td class="right-border">no</td>
                        <td>no</td>
                        <td>no</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can see site monitoring.</td>
                        <td>yes</td>
                        <td class="right-border">yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can comment site monitoring markings.</td>
                        <td>yes</td>
                        <td class="right-border">yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can approve marking as a proved or not approved in manager.</td>
                        <td>yes</td>
                        <td class="right-border">no</td>
                        <td>no</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can create a report from site monitoring.</td>
                        <td>no</td>
                        <td class="right-border">no</td>
                        <td>no</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can Publish and create project.</td>
                        <td>no</td>
                        <td class="right-border">no</td>
                        <td>no</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Unpublish project.</td>
                        <td>no</td>
                        <td class="right-border">no</td>
                        <td>no</td>
                        <td>no</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Delete project.</td>
                        <td>no</td>
                        <td class="right-border">no</td>
                        <td>no</td>
                        <td>no</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can assign new company account.</td>
                        <td>no</td>
                        <td class="right-border">no</td>
                        <td>no</td>
                        <td>no</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can delete company account.</td>
                        <td>no</td>
                        <td class="right-border">no</td>
                        <td>no</td>
                        <td>no</td>
                        <td>no</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Site monitoring marking lock/unlock/move/delete.</td>
                        <td>no</td>
                        <td class="right-border">no</td>
                        <td>no</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td colspan="7" class="text-white font-weight-bold"
                            style="background-color: #E20613; text-align: left;">Fuctions mobile.
                        </td>
                    </tr>
                    <tr>
                        <td class="column-1">Can see manager files.</td>
                        <td>no</td>
                        <td class="right-border">yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can download manager files.</td>
                        <td>no</td>
                        <td class="right-border">yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can see my files.</td>
                        <td>no</td>
                        <td class="right-border">yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can add markings.</td>
                        <td>no</td>
                        <td class="right-border">yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can see site monitoring.</td>
                        <td>yes</td>
                        <td class="right-border">yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can comment on site monitoring.</td>
                        <td>yes</td>
                        <td class="right-border">yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can sync marking.</td>
                        <td>no</td>
                        <td class="right-border">yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td class="column-1">Can send report.</td>
                        <td>no</td>
                        <td class="right-border">yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                        <td>yes</td>
                    </tr>
                    <tr>
                        <td colspan="7" class="text-white font-weight-bold"
                            style="background-color: #E20613; text-align: left;">General.
                        </td>
                    </tr>
                    <tr>
                        <td class="column-1">User account can be apart multiple companies.</td>
                        <td>yes</td>
                        <td class="right-border">yes</td>
                        <td>no</td>
                        <td>no</td>
                        <td>no</td>
                        <td>no</td>
                    </tr>
                    <tr>
                        <td class="column-1">Role can be apart of an other role.</td>
                        <td>yes</td>
                        <td class="right-border">yes</td>
                        <td>Cannot be &quot;insider&quot; in multiple companies with this account.</td>
                        <td>Cannot be &quot;insider&quot; in multiple companies with this account.</td>
                        <td>Cannot be &quot;insider&quot; in multiple companies with this account.</td>
                        <td>Cannot be &quot;insider&quot; in multiple companies with this account.</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="currentLanguage === 'fi'">
                <table class="table table-striped fs-5 border-1">
                    <thead style="position: sticky; top: 0; z-index: 1000; background: #fff;">
                    <tr>
                        <th class="column-1"></th>
                        <th colspan="2" class="right-border">Organisaation ulkopuoliset jäsenet</th>
                        <th colspan="5">Organisaation jäsenet (oma henkilökunta)</th>
                    </tr>
                    <tr class="font-weight-bold">
                        <td class="column-1">Roolit</td>
                        <td>Valvoja (outside inspector)</td>
                        <td class="right-border">Alihankkija (subcontractor)</td>
                        <td>Käyttäjä (user)</td>
                        <td>Projektipäällikkö (project manager)</td>
                        <td>Yritys-manager (company manager)</td>
                        <td>Ylläpitäjä (admin)</td>
                    </tr>
                    <tr>
                        <td class="column-1">Roolin lyhyt kuvaus.</td>
                        <td style="font-size: 11px;">Voi tarkastella Sivuston hallinta -osaa ja kommentoida merkintöjä mobiilissa ja Site monitoring-osiossa (vain niissä projekteissa, joihin heidät on lisätty).
                        </td>
                        <td style="font-size: 11px;" class="right-border">Voi työskennellä vain niissä projekteissa, joihin heidät on lisätty, ei voi tarkastella muita projekteja.
                        </td>
                        <td style="font-size: 11px;">Voi työskennellä vain niissä projekteissa, joihin heidät on lisätty, ei voi tarkastella muita projekteja.
                        </td>
                        <td style="font-size: 11px;">Kaikki ominaisuudet käytettävissä paitsi
                            tuotteiden/raporttien/työkalujen/projektikäyttäjien poistaminen.
                        </td>
                        <td style="font-size: 11px;">Kaikki ominaisuudet käytettävissä paitsi Käyttäjien poistaminen yritystasolta.
                        </td>
                        <td style="font-size: 11px;">Ei rajoituksia ominaisuuksiin.</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td colspan="7" class="text-white font-weight-bold"
                            style="background-color: #E20613; text-align: left;">Toiminnot Manager-sovellukselle.
                        </td>
                    </tr>
                    <tr>
                        <td class="column-1">Näe projektit, joihin heidät on määrätty.</td>
                        <td>kyllä</td>
                        <td class="right-border">kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Salasanan vaihto mahdollista ylläpitäjän toimesta.</td>
                        <td>ei (salasanaa ei voi luoda mikään yrityksen ylläpitäjä).</td>
                        <td class="right-border">ei (salasanaa ei voi luoda mikään yrityksen ylläpitäjä).</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi nähdä projektin hallintapaneelin.</td>
                        <td>kyllä</td>
                        <td class="right-border">kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi muokata projektin hallintapaneelia ja sen toimintoja.</td>
                        <td>ei</td>
                        <td class="right-border">ei</td>
                        <td>ei</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi nähdä tiedostot.</td>
                        <td>kyllä</td>
                        <td class="right-border">kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi muokata tiedostoja.</td>
                        <td>ei</td>
                        <td class="right-border">ei</td>
                        <td>ei</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi nähdä tuotteet.</td>
                        <td>kyllä</td>
                        <td class="right-border">kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi muokata omia tuotteita.</td>
                        <td>ei</td>
                        <td class="right-border">ei</td>
                        <td>ei</td>
                        <td>ei</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi nähdä sivuston työkalut.</td>
                        <td>ei</td>
                        <td class="right-border">kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi lisätä sivuston työkaluja.</td>
                        <td>ei</td>
                        <td class="right-border">ei</td>
                        <td>ei</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi poistaa sivuston työkaluja.</td>
                        <td>ei</td>
                        <td class="right-border">ei</td>
                        <td>ei</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi nähdä raportit.</td>
                        <td>kyllä</td>
                        <td class="right-border">kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi muokata raportteja.</td>
                        <td>ei</td>
                        <td class="right-border">ei</td>
                        <td>ei</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi poistaa raportteja.</td>
                        <td>ei</td>
                        <td class="right-border">ei</td>
                        <td>ei</td>
                        <td>ei</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi nähdä sivuston "site monitoring-osion".</td>
                        <td>kyllä</td>
                        <td class="right-border">kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi kommentoida sivuston "site motoring" osiossa olevia merkintöjä.</td>
                        <td>kyllä</td>
                        <td class="right-border">kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi hyväksyä merkinnän hyväksytyksi tai ei hyväksytyksi hallinnassa.</td>
                        <td>kyllä</td>
                        <td class="right-border">ei</td>
                        <td>ei</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi luoda raportin sivuston valvonnasta.</td>
                        <td>ei</td>
                        <td class="right-border">ei</td>
                        <td>ei</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi julkaista ja luoda projektin.</td>
                        <td>ei</td>
                        <td class="right-border">ei</td>
                        <td>ei</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi poistaa projektin julkaisun.</td>
                        <td>ei</td>
                        <td class="right-border">ei</td>
                        <td>ei</td>
                        <td>ei</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi poistaa projektin.</td>
                        <td>ei</td>
                        <td class="right-border">ei</td>
                        <td>ei</td>
                        <td>ei</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi määrittää uuden yritystilin.</td>
                        <td>ei</td>
                        <td class="right-border">ei</td>
                        <td>ei</td>
                        <td>ei</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi poistaa yritystilin.</td>
                        <td>ei</td>
                        <td class="right-border">ei</td>
                        <td>ei</td>
                        <td>ei</td>
                        <td>ei</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Sivuston valvonnan merkintöjen lukitseminen/avaaminen/siirtäminen/poistaminen.</td>
                        <td>ei</td>
                        <td class="right-border">ei</td>
                        <td>ei</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td colspan="7" class="text-white font-weight-bold"
                            style="background-color: #E20613; text-align: left;">Toiminnot mobiilissa.
                        </td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi nähdä "manager- välilehden" sisällön.</td>
                        <td>ei</td>
                        <td class="right-border">kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi ladata "manager- välilehdeltä" projekteja.</td>
                        <td>ei</td>
                        <td class="right-border">kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi nähdä omat tiedostot.</td>
                        <td>ei</td>
                        <td class="right-border">kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi lisätä merkintöjä.</td>
                        <td>ei</td>
                        <td class="right-border">kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi nähdä "Site monitoring- välilehden" sisällön.</td>
                        <td>kyllä</td>
                        <td class="right-border">kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi kommentoida "sitemonitoring- välilehden" merkintöjä.</td>
                        <td>kyllä</td>
                        <td class="right-border">kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi synkronoida merkinnän.</td>
                        <td>ei</td>
                        <td class="right-border">kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td class="column-1">Voi lähettää raportin.</td>
                        <td>ei</td>
                        <td class="right-border">kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                        <td>kyllä</td>
                    </tr>
                    <tr>
                        <td colspan="7" class="text-white font-weight-bold"
                            style="background-color: #E20613; text-align: left;">Yleistä.
                        </td>
                    </tr>
                    <tr>
                        <td class="column-1">Käyttäjätili voi olla osa useita yrityksiä.</td>
                        <td>kyllä</td>
                        <td class="right-border">kyllä</td>
                        <td>ei</td>
                        <td>ei</td>
                        <td>ei</td>
                        <td>ei</td>
                    </tr>
                    <tr>
                        <td class="column-1">Rooli voi olla osa toista roolia.</td>
                        <td>kyllä</td>
                        <td class="right-border">kyllä</td>
                        <td>Voi kommentoida "sitemonitoring- välilehden" merkintöjä.</td>
                        <td>Ei ole mahdollista olla tällä roolilla useissa eri organisaatioissa.</td>
                        <td>Ei ole mahdollista olla tällä roolilla useissa eri organisaatioissa.</td>
                        <td>Ei ole mahdollista olla tällä roolilla useissa eri organisaatioissa.</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            currentLanguage: 'fi',
        };
    },
    methods: {
        setLanguage(language) {
            this.currentLanguage = language;
        },
    },
};
</script>

<style>
.right-border {
    border-right: 2px solid #f70000 !important;
}
.column-1{
    border-right: 2px solid #f70000 !important;
}
</style>
